import { AccountAuthorizationsContext } from "core/cuenta/contexts/AccountAuthorizationsContext";
import { useContext } from "react"
import { AccountAuthorizationTable } from "../AccountAuthorizationTable/AccountAuthorizationTable";

export const AccountAuthorizationList = () => {
  const {
    authorizations
  } = useContext(AccountAuthorizationsContext);

  return (
    <AccountAuthorizationTable
      authorizations={authorizations.autorizaciones}
    />)
}